















import { GPageBase } from '@/mixins';
import { mixins } from 'vue-class-component';
import { Component } from 'vue-property-decorator';
import { GrowthMindsetMap } from '@/models/school-group/school-group-trend-analysis';
import { statisticsModule } from '@/store/modules/frames/statistics.module';
import GTrendAnalysisGrowthMindsetMapChart from '@/views/GClassManagement/GTrendAnalysisGrowthMindsetMapChart.vue';

@Component({
  name: 'GClassManagementTrendAnalysisGrowthMindsetMap',
  components: {
    GTrendAnalysisGrowthMindsetMapChart,
  },
})
export default class GClassManagementTrendAnalysisGrowthMindsetMap extends mixins(GPageBase) {
  growthMindsetMapDescriptionsColumn: object[] = [];
  growthMindsetMapDescriptions: object[] = [];

  mounted() {
    this.createColumn();

    this.growthMindsetMapDescriptions = [
      {
        zone: this.$t('GROWTH_MIND_SET_MAP_DESC_ZONE_1').toString(),
        score: this.$t('GROWTH_MIND_SET_MAP_DESC_SCORE_1').toString(),
        description: this.$t('GROWTH_MIND_SET_MAP_DESC_DESCRIPTION_1').toString(),
        favoritePhrase: this.$t('GROWTH_MIND_SET_MAP_DESC_FAVORITE_PHRASE_1').toString(),
      },
      {
        zone: this.$t('GROWTH_MIND_SET_MAP_DESC_ZONE_2').toString(),
        score: this.$t('GROWTH_MIND_SET_MAP_DESC_SCORE_2').toString(),
        description: this.$t('GROWTH_MIND_SET_MAP_DESC_DESCRIPTION_2').toString(),
        favoritePhrase: this.$t('GROWTH_MIND_SET_MAP_DESC_FAVORITE_PHRASE_2').toString(),
      },
      {
        zone: this.$t('GROWTH_MIND_SET_MAP_DESC_ZONE_3').toString(),
        score: this.$t('GROWTH_MIND_SET_MAP_DESC_SCORE_3').toString(),
        description: this.$t('GROWTH_MIND_SET_MAP_DESC_DESCRIPTION_3').toString(),
        favoritePhrase: this.$t('GROWTH_MIND_SET_MAP_DESC_FAVORITE_PHRASE_3').toString(),
      },
      {
        zone: this.$t('GROWTH_MIND_SET_MAP_DESC_ZONE_4').toString(),
        score: this.$t('GROWTH_MIND_SET_MAP_DESC_SCORE_4').toString(),
        description: this.$t('GROWTH_MIND_SET_MAP_DESC_DESCRIPTION_4').toString(),
        favoritePhrase: this.$t('GROWTH_MIND_SET_MAP_DESC_FAVORITE_PHRASE_4').toString(),
      },
    ];
  }

  get schoolGroupTrendAnalysisGrowthMindsetMap(): GrowthMindsetMap {
    return statisticsModule.schoolGroupTrendAnalysis.growthMindsetMap;
  }

  createColumn(): void {
    this.growthMindsetMapDescriptionsColumn = [this.zone, this.score, this.description, this.favoritePhrase];
  }

  get zone(): any {
    return {
      title: this.$t('ZONE').toString(),
      key: 'zone',
      width: 140,
      align: 'left',
    };
  }

  get score(): any {
    return {
      title: this.$t('SCORE').toString(),
      key: 'score',
      width: 130,
      align: 'left',
      render: (h: any, params: any) => {
        return this.renderIViewTableCellWithLineBreaks(h, params.row.score);
      },
    };
  }

  get description(): any {
    return {
      title: this.$t('SENTENCE').toString(),
      key: 'description',
      align: 'left',
      className: "word-break-normal",
    };
  }

  get favoritePhrase(): any {
    return {
      title: this.$t('FAVORITE_SAYING').toString(),
      key: 'favoritePhrase',
      width: 180,
      align: 'left',
      render: (h: any, params: any) => {
        return this.renderIViewTableCellWithLineBreaks(h, params.row.favoritePhrase);
      },
    };
  }
}
